// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__Lc5Wl","icon":"Intro_icon__L90us","introTitle":"Intro_introTitle__UK4DF","introSummary":"Intro_introSummary__SnYQp"};